<div class="custom-modal-container">
  <div class="custom-modal-container-content {{ context.classes ? context.classes : 'primary' }}">
    <div (click)="onClose()" class="close-button" *ngIf="context && !context.isClose">
      <svg class="icon-svg">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#dialog-cross"></use>
      </svg>
    </div>
    <div class="modal-icon {{ context.classPopup }}" [ngClass]="{ done: context.status }" *ngIf="context && context.svg">
      <svg class="icon-svg">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" [attr.xlink:href]="context.svg.xlinkHref"></use>
      </svg>
    </div>
    <div class="content-container">
      <h2 class="modal-title" *ngIf="context && context.title">{{ context.title | translate }}</h2>
      <div class="modal-paragraph-wrap">
        <p class="modal-paragraph" *ngIf="context && context.description" [innerHTML]="context.description | translate"></p>
        <p class="modal-paragraph" *ngIf="context && context.descriptionInfo" [innerHTML]="context.descriptionInfo | translate"></p>
      </div>
      <div class="apply-btn-wrap {{ context.classPopup }} {{ context.buttonsClass }}" *ngIf="context && context.buttons">
        <a class="apply-btn {{ button.classes }}" *ngFor="let button of context.buttons" (click)="onClick(button.callback)">{{
          button.text | translate
        }}</a>
      </div>
      <a href="{{ context.link.url }}" *ngIf="context.link" target="_blank">{{ context.link.text | translate }}</a>
    </div>
  </div>
</div>
